import React, { useState } from 'react';
import Button from '../../library/Button/button';

interface OwnerActionTooltipProps {
  onClick: () => void;
  label: string;
  icon: React.ReactNode;
}

export const OwnerActionTooltip: React.FC<OwnerActionTooltipProps> = ({ onClick, label, icon }) => {
  const [isShowing, setIsShowing] = useState(false);
  return (
    <Button
      onclick={onClick}
      onMouseEnter={() => setIsShowing(true)}
      onMouseLeave={() => setIsShowing(false)}>
      {icon}
      {isShowing && (
        <div className="group flex relative">
          <span className="px-1 py-1 group-hover:opacity-100 transition-opacity text-sm text-gray-500 bg-white border border-gray-200 rounded-lg shadow-sm absolute -top-24 left-1/2 -translate-x-1/2 translate-y-full m-4 mx-auto">
            {label}
          </span>
        </div>
      )}
    </Button>
  );
};
